<template>
  <main class="l-main p-register">
    <div class="l-block">
      <TitleRegister>
        <Progress :items="progress" />
      </TitleRegister>
      <div class="l-block__content provisional">
        <div class="message">
          <h1>
            パスワード再設定メールを送信しました！<br />再設定メールをご確認ください。
          </h1>
          <div class="c-text--center">
            <img
              :src="require('@/assets/img/img-register-provisional.gif')"
              alt="パスワード再設定メールを送信しました！"
            />
          </div>
          <p>
            しばらく経ってもメールが届かない場合は、カスタマーサポート(<a
              :href="'mailto:' + $constants.customerSupportEmail"
              >{{ $constants.customerSupportEmail }}</a
            >)まで<br />ご連絡いただきますようお願いいたします。
          </p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Progress from '@/components/Progress';
import TitleRegister from '@/components/TitleRegister';

export default {
  components: {
    Progress,
    TitleRegister
  },
  data() {
    return {
      progress: [
        {
          label: 'アドレス入力'
        },
        {
          current: true,
          label: '送信完了'
        }
      ]
    };
  }
};
</script>
